export const SEARCH_FILTERS = [
  { value: 'term', label: 'Dispute ID' },
  { value: 'reason', label: 'Reason' },
];

export const INFORMATION_REQUESTED = 'information_requested';
export const NOTIFICATION_RECEIVED = 'notification_received';
export const FIRST_CHARGEBACK = '1st_chargeback';
export const DEFENSE_DECLINED = 'defense_declined';
export const DEFENSE_ACCEPTED = 'defense_accepted';
export const WON = 'won';
export const LOST = 'lost';
export const CHARGE_REFUNDED = 'charge_refunded';
export const UNDER_REVIEW = 'under_review';
export const NEEDS_RESPONSE = 'needs_response';
export const CLOSED = 'closed';
export const EVIDENCE_SUBMITTED = 'evidence_submitted';

const REQUEST_FOR_INFORMATION = 'REQUEST_FOR_INFORMATION';
const NOTIFICATION_OF_CHARGEBACK = 'NOTIFICATION_OF_CHARGEBACK';
const CHARGEBACK = 'CHARGEBACK';
const SECOND_CHARGEBACK = 'SECOND_CHARGEBACK';
const CHARGEBACK_REVERSED = 'CHARGEBACK_REVERSED';
const PREARBITRATION_WON = 'PREARBITRATION_WON';
const PREARBITRATION_LOST = 'PREARBITRATION_LOST';
const WARNING_NEEDS_RESPONSE = 'warning_needs_response';
const WARNING_UNDER_REVIEW = 'warning_under_review';
const WARNING_CLOSED = 'warning_closed';

export const CUSTOM_DISPUTE_STATUSES = {
  [REQUEST_FOR_INFORMATION]: INFORMATION_REQUESTED,
  [NOTIFICATION_OF_CHARGEBACK]: NOTIFICATION_RECEIVED,
  [CHARGEBACK]: FIRST_CHARGEBACK,
  [SECOND_CHARGEBACK]: DEFENSE_DECLINED,
  [CHARGEBACK_REVERSED]: DEFENSE_ACCEPTED,
  [PREARBITRATION_WON]: WON,
  [PREARBITRATION_LOST]: LOST,
  [WARNING_NEEDS_RESPONSE]: NEEDS_RESPONSE,
  [WARNING_UNDER_REVIEW]: UNDER_REVIEW,
  [WARNING_CLOSED]: CLOSED,
};
export const STATUS_FILTERS = [
  { label: 'Accepted', value: DEFENSE_ACCEPTED },
  { label: 'Declined', value: DEFENSE_DECLINED },
  { label: 'Won', value: WON },
  { label: 'Lost', value: LOST },
  { label: 'Under Review', value: UNDER_REVIEW },
  { label: 'Information Requested', value: INFORMATION_REQUESTED },
  { label: 'Notification Received', value: NOTIFICATION_RECEIVED },
  { label: '1st Chargeback', value: FIRST_CHARGEBACK },
  { label: 'Charge Refunded', value: CHARGE_REFUNDED },
  { label: 'Needs Response', value: NEEDS_RESPONSE },
  { label: 'Closed', value: CLOSED },
];
